import type { EnumLabelLanguage } from '@/utils/enum-label'
import { createStore } from './createStore'

type LanguageState = {
  language: EnumLabelLanguage
  setLanguage: (language: EnumLabelLanguage) => void
}

export const useLanguageStore = createStore<LanguageState>(
  set => ({
    language: 'th',
    setLanguage: language => set({ language }),
  }),
  'LanguageStore',
)
